import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import staticCities from "../../../data/city";
import useApp from "../../../hooks/useApp";
import { getCitiesByCampaignId_V2 } from "../../../Services_V2/City.service";
import cn from "../../../utils/cn";
import styles from "./ngo-donate.module.css";

// Update this interface to match your actual API response
interface ICity {
  _id: string;
  city: string; // string, not object
  state: string;
  country: string;
  createdBy?: string;
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
}

const NGOLanding = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const voting = searchParams.get("voting");
  const campaignId = searchParams.get("campaignId");

  const { organization } = useParams<{ organization: string }>();

  const {
    state: { organization: organizationDetails },
    dispatch,
  } = useApp();

  const [cities, setCities] = useState<ICity[]>([]);
  const [loading, setLoading] = useState(true);

  const showGlobalLoader = useCallback(
    (show: boolean) =>
      dispatch({ type: "updateState", payload: { pageLoader: show } }),
    [dispatch]
  );

  const fetchData = useCallback(async () => {
    if (!campaignId) {
      setLoading(false);
      return;
    }

    showGlobalLoader(true);
    setLoading(true);

    try {
      const res = await getCitiesByCampaignId_V2(campaignId);

      if (res?.success && Array.isArray(res.data)) {
        setCities(res.data);
      } else {
        setCities([]);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
      setCities([]);
    } finally {
      showGlobalLoader(false);
      setLoading(false);
    }
  }, [campaignId, showGlobalLoader]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div>
      <div className={styles.header}>
        <h2>{organizationDetails?.title || "Loading..."}</h2>
        <p>{organizationDetails?.description || ""}</p>
      </div>

      {loading ? (
        <p className="text-center text-white" style={{ marginTop: "40px" }}>
          Loading cities...
        </p>
      ) : !!cities.length ? (
        <div className={styles.cityContainer}>
          <p className={styles.title}>Select your city</p>
          <div className={styles.cardWrapper}>
            {/* Optional: Show "All Cities" only if more than one city */}
            {cities.length > 1 && organizationDetails && (
              <div
                className={cn(styles.card)}
                onClick={() =>
                  navigate(
                    `/${organization}/donate/ngos?organization=${
                      organizationDetails._id
                    }&all=yes${
                      voting && organizationDetails.isVoting
                        ? `&voting=${voting}`
                        : ""
                    }`
                  )
                }
              >
                <p>All Cities</p>
              </div>
            )}

            {cities.map((cityData) => {
              const { _id, city: cityName } = cityData;
              const Icon = staticCities.find(
                ({ name }) => name === cityName
              )?.icon;

              return (
                <div
                  key={_id}
                  className={cn(styles.card)}
                  onClick={() =>
                    organizationDetails &&
                    navigate(
                      `/${organization}/donate/ngos?organization=${
                        organizationDetails._id
                      }&city=${_id}&cityName=${encodeURIComponent(cityName)}${
                        voting && organizationDetails.isVoting
                          ? `&voting=${voting}`
                          : ""
                      }`
                    )
                  }
                >
                  {Icon && <Icon width={100} height={80} />}
                  <p>{cityName}</p>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <p className="text-center text-white" style={{ marginTop: "40px" }}>
          Cities not available for this campaign.
        </p>
      )}
    </div>
  );
};

export default NGOLanding;
